import { vehicleOilCard } from '@/api/index'

export function ImportCardMaterialMain (data) {
  return vehicleOilCard.request({
    method: 'post',
    url: '/ImportCardMaterialMain',
    data,
    iSFromData: true
  })
}

export function DeleteIntoCardMaterialExcel (data) {
  return vehicleOilCard.request({
    method: 'post',
    url: '/DeleteIntoCardMaterialExcel',
    data
  })
}

export function InitializationTemplate (data) {
  return vehicleOilCard.request({
    method: 'post',
    url: '/InitializationTemplate',
    data
  })
}

export function GetCardMaterialflag (data) {
  return vehicleOilCard.request({
    method: 'post',
    url: '/GetCardMaterialflag',
    data
  })
}

export function ImportCardMaterialData (data) {
  return vehicleOilCard.request({
    method: 'post',
    url: '/ImportCardMaterialData',
    data
  })
}

export function Get_Template_Main (data) {
  return vehicleOilCard.request({
    method: 'post',
    url: '/Get_Template_Main',
    data
  })
}

export function GetIntoCardMaterialExcel (data) {
  return vehicleOilCard.request({
    method: 'post',
    url: '/GetIntoCardMaterialExcel',
    data
  })
}
export function CardMaterialTemplateDelete (data) {
  return vehicleOilCard.request({
    method: 'post',
    url: '/CardMaterialTemplateDelete',
    data
  })
}
export function oilCardGetPageGridBond (data) {
  return vehicleOilCard.request({
    method: 'post',
    url: '/GetPageGridBond',
    data
  })
}
export function oilCardSavePGSData (data) {
  return vehicleOilCard.request({
    method: 'post',
    url: '/SavePGSData',
    data
  })
}
